import { Link } from 'react-router-dom';
import { categories } from '@/mocks/homeData';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="py-10 md:py-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 group">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-play-circle-fill text-xl text-primary-400"></i>
              </div>
              <span className="text-lg font-bold font-heading whitespace-nowrap">番茄视频</span>
            </Link>
            <p className="text-sm text-background-300 leading-relaxed">
              聚合妖精视频、桃花视频、苹果视频等特色内容，高清画质免费在线观看，发现更多精彩。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 font-heading">内容分类</h4>
            <ul className="space-y-2">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.slug}>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-background-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 font-heading">特色频道</h4>
            <ul className="space-y-2">
              <li><span className="text-sm text-background-300 cursor-pointer hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">妖精视频</span></li>
              <li><span className="text-sm text-background-300 cursor-pointer hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">桃花视频</span></li>
              <li><span className="text-sm text-background-300 cursor-pointer hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">苹果视频</span></li>
              <li><span className="text-sm text-background-300 cursor-pointer hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">榴莲视频</span></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 font-heading">关于我们</h4>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-sm text-background-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">品牌介绍</Link></li>
              <li><span className="text-sm text-background-300 cursor-pointer hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">用户口碑</span></li>
              <li><span className="text-sm text-background-300 cursor-pointer hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">联系方式</span></li>
              <li><span className="text-sm text-background-300 cursor-pointer hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">加入我们</span></li>
            </ul>
            <div className="flex gap-3 mt-4">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-300/20 hover:bg-primary-500/30 transition-colors duration-200 cursor-pointer">
                <i className="ri-wechat-line text-sm"></i>
              </div>
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-300/20 hover:bg-primary-500/30 transition-colors duration-200 cursor-pointer">
                <i className="ri-weibo-line text-sm"></i>
              </div>
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-300/20 hover:bg-primary-500/30 transition-colors duration-200 cursor-pointer">
                <i className="ri-bilibili-line text-sm"></i>
              </div>
            </div>
          </div>
        </div>

        <div className="py-5 border-t border-background-300/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-400">© 2026 番茄视频 FanQieShipin.com 版权所有</p>
          <div className="flex gap-4">
            <span className="text-xs text-background-400 cursor-pointer hover:text-background-300 transition-colors duration-200 whitespace-nowrap">隐私政策</span>
            <span className="text-xs text-background-400 cursor-pointer hover:text-background-300 transition-colors duration-200 whitespace-nowrap">服务条款</span>
            <span className="text-xs text-background-400 cursor-pointer hover:text-background-300 transition-colors duration-200 whitespace-nowrap">版权声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}